import { PromotionType } from '@hooks-api/types/dataModel/coupon'
import { type MergedCoupon, type MergedCouponCriterionWithCoupon } from '../types'

export const parseGiveaways = (mergedCoupons: MergedCoupon[] | undefined): MergedCouponCriterionWithCoupon[] | undefined => {
  const filteredCoupons = mergedCoupons?.filter(coupon => !coupon.is_regular_giveaway && coupon.promotionTypes.has(PromotionType.GIVEAWAY))
  return filteredCoupons?.flatMap(giveaway => giveaway.criterions.map(criterion => ({
    ...criterion,
    coupon: giveaway,
  })))
}
